// extracted by mini-css-extract-plugin
export default {"seven":"SecSeven_seven__Jdu6E"};